import { View, Text } from '@react-pdf/renderer'
import HeaderPDFDefault from '../HeaderPDFDefault'
import ReportIndicadoresAcademicosPDF from './ReportIndicadoresAcademicosPDF'

export default function IndicadoresAcademicosPDF({
    metadata,
    data,
    title,
    campus,
    startDate,
    endDate,
    ciclo = "",
    escuela = "",
    direccion = "",
    tipo_clase = ""
}) {
    return (
        <View>
            <HeaderPDFDefault title={title} />
            <ReportIndicadoresAcademicosPDF
                metadata={metadata}
                data={data}
                campus={campus}
                startDate={startDate}
                endDate={endDate}
                ciclo={ciclo}
                escuela={escuela}
                direccion={direccion}
                tipo_clase={tipo_clase}
            />
            <View
                fixed
                style={{
                    height: 50,
                    position: 'absolute',
                    bottom: 30,
                    left: 0,
                    right: 0,
                    top: 520
                }}
            >
                <View
                    style={{
                        flexDirection: 'row',
                        justifyContent: 'flex-end'
                    }}
                >
                    <View>
                        <Text
                            style={{
                                color: 'gray',
                                fontSize: 11,
                            }}
                            render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
                        />
                    </View>
                </View>
            </View>
        </View>
    )
}